import React, { useEffect } from 'react';



import {
  Content,
  ColContent,
  LineDashed,
  ColM,
  Line,
  LineDashedTwo
} from './styles'
import ChartBarTotal from '../../../graphs/ChartBarTotal';
import LegendChart from '../SubtitleChart';
import { useDispatch, useSelector } from 'react-redux';
import { getDefaultParams, getFormatedModulesPerformanceReport, StudentStateType } from '../../../common';
import { useExamType } from '../../../../../hooks/useExamType';
import { actions as studentActions } from '../../../../../redux/modules/student';
import { RECOMMENDED_CFP, RECOMMENDED_CFA } from '../../../constants/examRecommendations';
import { getPercentFormatted } from '../../../../../shared/utils/common'
type Props = {
  linePercent?: number;
  linePercentTwo?: number;
  displaySubtitle?: string,
  subtitleMin?: string,
  subtitleRecommended?: string,
  positionSubtitle?: string,
  recomended?: number,
  includeRevision?: boolean,
}

function BartChartV({
  linePercent,
  linePercentTwo,
  displaySubtitle,
  subtitleMin,
  subtitleRecommended,
  positionSubtitle,
  includeRevision,
}: Props) {

  const { reportSimulado: report } = useSelector((state: StudentStateType) => state.student);

  useEffect(() => {
    const { userId, courseId, classId, media, start, end, kind, classes } = getDefaultParams(window.location.search);
    dispatch(studentActions.handleCfpSimulado(
      userId,
      courseId,
      classId,
      media,
      start,
      end,
      kind,
      classes
    ));
    // eslint-disable-next-line
  }, []);

  const dispatch = useDispatch();

  const examConfig = useExamType();
  const maxModules = examConfig.settings.maxModules;
  const moduleFormattedReport = getFormatedModulesPerformanceReport(
    report?.module_performance, 
    maxModules, 
    examConfig.examType,
    includeRevision
  );
  
  const isCFA = examConfig.examType?.toUpperCase() === 'CFA';

  // Extrair configurações específicas por tipo de exame
  const chartConfig = isCFA ? {
    containerStyle: { 
      overflowX: 'auto' as const, 
      overflowY: 'visible' as const,
      width: '100%',
      maxWidth: '90vw',
      position: 'relative' as const,
      marginBottom: '0'
    },
    innerContainerStyle: { 
      minWidth: '60vw', 
      position: 'relative' as const, 
      paddingBottom: '0.5vw' 
    },
    colStyle: { 
      height: '15vw', 
      marginLeft: "5vw", 
      marginBottom: '-0.3vw' 
    },
    moduleGap: '0.4vw',
    lineStyle: { width: '81.5vw' },
    lineBottomStyle: { width: '78vw', marginBottom: '0' },
    colMStyle: { 
      width: '80vw', 
      display: 'flex' as const,
      gap: '0', 
      marginLeft: '5.4vw', 
      marginBottom: '0'
    },
    moduleStyle: { width: '7.8vw', textAlign: 'center' as const },
    legendStyle: { marginTop: '1vw' }
  } : {
    containerStyle: { 
      overflowX: 'visible' as const, 
      overflowY: 'visible' as const,
      width: '100%',
      position: 'relative' as const,
    },
    innerContainerStyle: { 
      position: 'relative' as const, 
    },
    colStyle: { 
      height: '15vw', 
      marginLeft: "5vw", 
      marginBottom: '-0.3vw' 
    },
    moduleGap: '0.5vw',
    lineStyle: { width: '81.5vw' },
    lineBottomStyle: { width: '78vw', marginBottom: '0' },
    colMStyle: { 
      width: '80vw', 
      display: 'flex' as const,
      gap: '0', 
      marginLeft: '5.5vw', 
      marginBottom: '0'
    },
    moduleStyle: { width: '8.5vw', textAlign: 'center' as const, marginLeft: '0.5vw' },
    legendStyle: { marginTop: '1vw' }
  };

  const getRecommended = (index: number): number => {
    const source = isCFA ? RECOMMENDED_CFA : RECOMMENDED_CFP;
    return source[index]?.value ?? 0;
  };

  return (
    <Content>
      <div style={chartConfig.containerStyle}>
        <div style={chartConfig.innerContainerStyle}>
          <ColContent xs={24} style={chartConfig.colStyle}>
            <>
              {(moduleFormattedReport ?? []).map((item, i) => {
                const recomended = getRecommended(i);
                return (
                  <div key={item.module} style={{ marginLeft: chartConfig.moduleGap }}>
                    <ChartBarTotal
                      result={getPercentFormatted(item.total)}
                      displayRecomended={recomended === 0 ? 'none' : 'flex'}
                      recomended={recomended}
                    />
                  </div>
                )
              })}
            </>
            <LineDashedTwo linePercentTwo={linePercentTwo} style={chartConfig.lineStyle} />
            <LineDashed linePercent={linePercent} style={chartConfig.lineStyle} />
          </ColContent>
          <Line style={chartConfig.lineBottomStyle} />
          <ColM style={chartConfig.colMStyle}>
            {(moduleFormattedReport ?? []).map((item) => (
              <h3 key={item.module} style={chartConfig.moduleStyle}>
                {item.module}
              </h3>
            ))}
          </ColM>
        </div>
      </div>

      <div style={chartConfig.legendStyle}>
        <LegendChart
          displaySubtitle={displaySubtitle}
          subtitleMin={subtitleMin}
          subtitleRecommended={subtitleRecommended}
          positionSubtitle={positionSubtitle}
        />
      </div>
    </Content>
  );
};

export default BartChartV;
